<div class="card">
  <ng-container *ngIf="paymentMethodTemplate?.meta?.subscriptionTypeVO">
    <div class="d-flex mb-5 justify-content-center">
      <div class="w-100 subscription-card">
        <well-subscription-card-view-wrapper
          [subscription]="paymentMethodTemplate.meta.subscriptionTypeVO"
          class="subscription-type mx-xs"
        >
        </well-subscription-card-view-wrapper>
      </div>

    </div>


  </ng-container>

  <ng-container *ngIf="paymentMethodTemplate?.meta?.paymentMethodTypes">
    <well-payment-method-inputs (save)="onSave($event)"
                                [methods]="paymentMethodTemplate.meta.paymentMethodTypes"
                                [model]="paymentMethodTemplate?.data"
                                [showTermsAndConditions]="showTermsAndConditions" data-testid="payment-method-inputs-input"></well-payment-method-inputs>
  </ng-container>
</div>



